// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";
// Action Types
import {
    MAP_LANDMARKS_DELETE_LANDMARK_GROUPS,
} from "Redux/actionTypes";

// Actions
import {
    mapLandmarksDeleteLandmarkGroupsResponse,
    getLandmarksAndGeofences as getKmls
} from "Redux/actions";

// Helpers
import { clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";
import { ExceptionManager } from "Core/logManager";

function* deleteLandmarkGroupsRequest({ payload }) {
    try {
        const { ids, newId } = payload;

        let mutations = [];
        ids.forEach((id, index) => {
          mutations.push(
            `Group${index}: deleteLandmarkGroup(
              id: ${id}
              ${newId ? `moveChildsToGroupId: ${newId}` : ''}
            )`
          );
        });
    
        let mutation = `mutation { ${mutations.join(" ")} }`;
    
        let response = yield call(
          clientMutation,
          mutation,
          {},
          endpoints.GRAPHQL_GENERAL,
        );

        if (!response) throw `Error while deleting landmarks groups, ${ids} ${newId}`;

        yield put(mapLandmarksDeleteLandmarkGroupsResponse({ ...response, error: false }));
        yield put(getKmls());
    } catch (exc) {
        yield put(mapLandmarksDeleteLandmarkGroupsResponse({ error: true }));
        ExceptionManager(
            exc,
            "realtimeMaps/main/components/landmarks/components/landmarkGroupDelete/redux/saga",
            "deleteLandmarkGroupsRequest"
        );
    }
}

function* watchDeleteLandmarkGroupsMethods() {
    yield takeEvery(MAP_LANDMARKS_DELETE_LANDMARK_GROUPS, deleteLandmarkGroupsRequest);
}

export default function* rootSaga() {
    yield all([fork(watchDeleteLandmarkGroupsMethods)]);
}